import { ReactNode } from "react";
import { ConfigProvider as AConfigProvider } from 'antd';
import frFR from 'antd/locale/fr_FR';
import enUS from 'antd/locale/en_US';
import deDE from 'antd/locale/de_DE';
import { useLocation } from "react-router-dom";
import { Locale } from "antd/es/locale";
import { Colors } from "../../../colors";

interface Props {
    children?: ReactNode;
}

const ConfigProvider = (props: Props) => {
    const location = useLocation();
    const lang = location.pathname.split('/')[1] ?? "fr";
    let local: Locale;

    switch (lang) {
        case "de": {
            local = deDE;
            break;
        }
        case "en": {
            local = enUS;
            break;
        }
        default: {
            local = frFR;
            break;
        }
    }

    return (
        <AConfigProvider
            locale={local}
            theme={{
                token: {
                    colorPrimary: Colors.base.primary.default
                },
                components: {
                    Layout: {
                        siderBg: 'white'
                    },
                    Menu: {
                        itemBg: 'red'
                    }
                },
            }}
        >
            {props.children}
        </AConfigProvider>
    );
};

export default ConfigProvider;